export default {"src":"/_next/static/media/logo-purple.94e68d5c.svg","height":42,"width":132,"blurWidth":0,"blurHeight":0};